export class ConditionVariable {
  private resolvePromise: (() => void) | null = null;
  private promise: Promise<void> | null = null; // always unresolved (or absent)

  public async wait(): Promise<void> {
    if (!this.promise) {
      this.promise = new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
      });
    }
    return this.promise;
  }

  public signal() {
    if (this.promise) {
      const resolvePromise = this.resolvePromise!;

      this.promise        = null;
      this.resolvePromise = null;

      resolvePromise();
    }
  }
}
